import {Controller} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';

import {showImportantInfoModalSelector} from './selectors';

const NAMESPACE = 'header';
const CACHE_MAX_AGE = 900; // 15 minutes

function loadMultiLayeredMenu() {
  return (dispatch, getState, {logger}) => {
    const storeId = getState().gsConfig.shstoreId;

    return get({
      host: process.env.REACT_APP_CMX_API_HOST,
      path: `/cms/content-content/homepage/site-nav/${storeId}.json`,
      proxy: process.env.REACT_APP_GENERAL_PROXY_SERVER,
      json: true,
      cache: true,

      cacheMaxAge: parseInt(process.env.REACT_APP_CACHE_TTL_CATALOG, 10) || CACHE_MAX_AGE,
      logger,
    })
      .then((body = {}) => {
        if (body.discovery) {
          dispatch({type: 'MULTILAYERNAV_CONTENT_LOADED', multiLayeredMenu: body});
        }

        return '';
      })
      .catch((e) => {
        logger && logger.error(e);
      });
  };
}

function handleImportantIconClick() {
  return (dispatch) => {
    dispatch({
      type: 'EVENT:DISCLAIMER:OPEN',
      forceShowDisclaimer: true,
    });
  };
}

const selectedCurrencySelector = ({currencyExchange = {}}) => currencyExchange.selectedCurrency;
const disableMwebSelector = ({gsConfig = {}}) => gsConfig.features && gsConfig.features['event.disableMwebHeader'];

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    const viewportState = state.viewport || {};
    const subCategoriesContent = state[NAMESPACE] && state[NAMESPACE].subCatNav;

    return {
      screenSize: viewportState.screenSize,
      subCategoriesContent,
      selectedCurrency: selectedCurrencySelector(state),
      hideOnMweb: disableMwebSelector(state),
      showImportantInfoModal: showImportantInfoModalSelector(state),
    };
  },
  actionCreators: {
    showSearchBarModal,
    loadMultiLayeredMenu,
    handleImportantIconClick,
  },
  reducers: ['SUBCATNAV_CONTENT_LOADED', 'MULTILAYERNAV_CONTENT_LOADED', 'EVENT:DISCLAIMER:OPEN'],
});

/**
 * Callback function that Dispatches 'SEARCH_BAR_MODAL_SHOW' event to Show the Search Bar.
 *
 */
function showSearchBarModal() {
  return (dispatch) => {
    const isModalSearchActive = true;
    dispatch({type: 'SEARCH_BAR_MODAL_SHOW', isModalSearchActive});
  };
}

export default controller;
